import { DetailedHTMLProps, FC, HTMLAttributes, JSX } from 'react';

import UploadIcon from '@/shared/ui/icons/Upload';

export interface IFileSelectorProps extends DetailedHTMLProps<
  HTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  onFileSelected: (file: File | null) => void;
  accept?: string;
}

export const FileSelector: FC<IFileSelectorProps> = ({
  onFileSelected,
  accept = '.svg, .png',
  ...props
}): JSX.Element => {
  const handleFiles = (fileList: FileList) => onFileSelected(fileList.item(0));

  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-gray/50"
      onDrop={(e) => {
        e.preventDefault();

        const fileList = e.dataTransfer.files;
        handleFiles(fileList);
      }}
      onDragOver={(e) => {
        e.preventDefault();
      }}
      onDragLeave={(e) => {
        e.preventDefault();
      }}
    >
      <UploadIcon width={32} height={32} />
      <div className="flex flex-col gap-1 text-center">
        <span className="text-sm font-light">
          <input
            type="file"
            id="file-input"
            className="hidden"
            accept={accept}
            onChange={(e) => onFileSelected(e?.target?.files?.[0] ?? null)}
            {...props}
          />
          <span>Drag file here or </span>
          <label htmlFor="file-input" className="underline">
            choose
          </label>
          <br />
          <span>on computer</span>
        </span>
        <span className="text-sm font-light text-gray/75">{accept}</span>
      </div>
    </div>
  );
};

export default FileSelector;
